export enum GridCommandOptionEnum {
    NotFound = 1,
    Create = 2,
    Delete = 3,
    ExportCsv = 4
}
